import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getNotificationSettings,
  updateNotificationSettings,
  type NotificationSettings,
  type NotificationSettingsPatch,
} from '../../lib/api';
import { queryKeys } from './queryKeys';

export const useNotificationSettings = (token: string | null) => {
  return useQuery({
    queryKey: queryKeys.notificationSettings.all,
    queryFn: () => getNotificationSettings(token as string),
    enabled: Boolean(token),
  });
};

export const useUpdateNotificationSettingsMutation = (token: string | null) => {
  const queryClient = useQueryClient();

  return useMutation<
    NotificationSettings,
    Error,
    NotificationSettingsPatch,
    { previous: NotificationSettings | undefined }
  >({
    mutationFn: (patch) => updateNotificationSettings(token as string, patch),
    onMutate: async (patch) => {
      await queryClient.cancelQueries({ queryKey: queryKeys.notificationSettings.all });
      const previous = queryClient.getQueryData<NotificationSettings>(queryKeys.notificationSettings.all);
      if (previous) {
        // 부분 저장이므로 이전 값 위에 patch만 덮어 낙관적 상태를 만든다.
        queryClient.setQueryData<NotificationSettings>(queryKeys.notificationSettings.all, { ...previous, ...patch });
      }
      return { previous };
    },
    onError: (_error, _patch, context) => {
      if (context?.previous) {
        queryClient.setQueryData(queryKeys.notificationSettings.all, context.previous);
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.notificationSettings.all });
    },
  });
};
